import React from 'react';
import Grid from '@material-ui/core/Grid';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import * as pbi from 'powerbi-client';
import api from '../../ApiService';
import { UserRoles, HospitalViewTabs } from '../../helper';
//import { UserRoles, HospitalViewTabs, IsMobile } from '../../helper';

const powerbi = new pbi.service.Service(pbi.factories.hpmFactory, pbi.factories.wpmpFactory, pbi.factories.routerFactory);

export default class Reports extends React.Component {

    constructor(props) {
        super(props);

        // remove?
        this.alertReportsComponentOfHospitalChange = this.alertReportsComponentOfHospitalChange.bind(this);

        this.state = {
            loading: true,
            selectedReport: { name: undefined, id: undefined }
        };
    }

    componentDidMount = async () => {
        this.props.alertReportsComponentOfHospitalChange(this.alertReportsComponentOfHospitalChange);
        await this.loadReports(this.props.selectedHospital);
        await this.alertReportsComponentOfHospitalChange(this.props.selectedHospital);
    }

    loadReports = async (selectedHospital) => {
        let reportType = 'Hospital';
        if (this.props.selectedTab === HospitalViewTabs.Analyst) reportType = 'Analyst';
        let reports = await api.getReports(reportType, selectedHospital.nameHash);

        if (reports) {

            let selectedReport = {
                name: undefined,
                id: undefined
            };

            if (reports.length === 1) {
                selectedReport.name = reports[0].name;
                selectedReport.id = reports[0].id;
            }

            this.setState({
                reports,
                selectedReport,
                loading: false
            }, async () => {
                if (selectedReport.id !== undefined)
                    await this.refreshEmbed(selectedHospital, selectedReport);
            });
        }
    }

    setDefaultServiceLevelReport = async (hospital) => {
        await this.loadReports(hospital);
        if (!this.state.selectedReport.id) {
            let defaultReport = this.state.reports.find(r => r.name === this.props.selectedHospital.serviceLevel.powerBiReportName);
            if (defaultReport !== undefined) {
                let selectedReport = {
                    id: defaultReport.id,
                    name: defaultReport.name
                }

                this.setState({
                    selectedReport
                })
            }
        }
        this.refreshEmbed(hospital, null);
    }

    alertReportsComponentOfHospitalChange = async (hospital) => {
        // For Super User, re-load the same report for a different hospital.
        // For Admins and StaffManagement, setting the service level report as default
        // For all other users, we must load the appropriate, hospital-specific report.
        if (this.props.userRole === UserRoles.SuperUser)
            this.refreshEmbed(hospital, null);
        else if (this.props.userRole === UserRoles.Administrator || this.props.userRole === UserRoles.StaffManagement)
            await this.setDefaultServiceLevelReport(hospital);
        else
            await this.loadReports(hospital);
    }

    handleChange = async (e) => {
        e.preventDefault(); // ?
        let selectedReport = this.state.reports.find((r) => { return r.id === e.target.value; });
        this.setState({ selectedReport: selectedReport });
        this.refreshEmbed(null, selectedReport);
    };

    embedReport = async (report) => {
        let accessToken = report.userEmbedToken;
        // Render report
        let reportId = report.id;
        let embedUrl = report.embedUrl;
        let config = {
            type: "report",
            tokenType: pbi.models.TokenType.Embed,
            accessToken: accessToken,
            embedUrl: embedUrl,
            id: reportId,
            permissions: pbi.models.Permissions.All,
            viewMode: pbi.models.ViewMode.View,
            pageView: 'fitToWidth',
            //filters:
            settings: {
                filterPaneEnabled: false,
                navContentPaneEnabled: true                
            }
        };

        //// mobile screen check for serving mobile versions of the reports.
        //// it only checks for commonly used mobiles though.
        //if (IsMobile) {
        //    config.settings.layoutType = pbi.models.LayoutType.MobilePortrait;
        //} else {
        //    config.settings.panes = {
        //        pageNavigation: {
        //            visible: true,
        //            position: 1
        //        }
        //    }
        //}

        let embedDiv = document.getElementById('embedDiv');
        if (embedDiv !== null) {
            // Note: if a report already is in the dev, then replacing it like this causes
            // a console error with v2.6.5; version 2.6.4 is fine
            // see https://community.powerbi.com/t5/Developer/Replace-powerbi-report-on-same-div-with-a-new-one/m-p/556491/highlight/false#M17422
            powerbi.reset(embedDiv);
            let embeddedReport = powerbi.embed(embedDiv, config);
            if (embeddedReport.embeType !== 'report') return;
        }
    }

    initEmbeddedReport() {
        let style = { margin: 0, padding: 0, minHeight: "450px", height: "75vh", width: "100%" };
        //let style = { width: "100%" };
        return (
            <div className={"embedWrapper" + (this.state.loading ? " hidden" : "")}>
                <div id="embedDiv" className="powerbi-container" style={style} ref={(ref) => this.embedContainer = ref} />
            </div>
        );
    }

    refreshEmbed = async (hospital, report) => {
        if (!hospital) hospital = this.props.selectedHospital;
        if (!report) report = this.state.selectedReport;

        if (!report.id && !hospital.id) return; // nothing to do (blank out report?)

        if (!report) report = this.state.reports[0];
        let reportType = 'Hospital';
        if (this.props.selectedTab === HospitalViewTabs.Analyst) reportType = 'Analyst';

        let pbiReport = await api.getReport(report.id, this.props.selectedHospital.nameHash, reportType);
        if (pbiReport) {
            report.userEmbedToken = pbiReport.token;
            report.embedUrl = pbiReport.embedUrl;
            this.embedReport(report);
        }
    }

    toggleFullscreen = (e) => {
        e.preventDefault();
        let report = powerbi.get(this.embedContainer);
        report.fullscreen();
    }

    // For Igloo
    getReportUrl = () => {
        let location = window.location;
        let port = (location.port === '80' || location.port.length === 0) ? '' : `:${location.port}`;
        let reportUrl = `${location.protocol}//${location.hostname}${port}/#/report/${this.state.selectedReport.id}/${this.props.selectedHospital.nameHash}`;

        // !!! Until we add a front end page to support this, redirect to the existing site
        //let reportUrl = `https://ivet360data.azurewebsites.net/#/report/${this.state.selectedReport.id}/${this.props.selectedHospital.nameHash}`;

        let encapsulatedReportUrl = `<iframe src="${reportUrl}" width="1100" height="900" scrolling="no" frameborder="0"></iframe>`;
        return encapsulatedReportUrl;
    }

    renderReportList(reports) {
        return (
            <Grid item xs={6}>
                {reports.length > 1 &&
                    <FormControl fullWidth style={{ padding: '0px 15px 0px 0px' }}>
                        <InputLabel htmlFor="reportId" style={{ fontWeight: 'normal' }}>Report</InputLabel>
                        <Select
                            value={this.state.selectedReport.id || ''}
                            onChange={this.handleChange}
                            inputProps={{ name: 'reportId', id: 'reportId' }}
                        >
                            {reports.map(r =>
                                <MenuItem key={r.id} value={r.id}>{r.name}</MenuItem>
                            )}
                        </Select>
                    </FormControl>
                }
            </Grid>
        );
    }

    render() {
        let reportList = this.state.loading
            ? <p style={{ padding: '10px' }}><em>Loading...</em></p>
            : this.renderReportList(this.state.reports);
        let embeddedReport = this.initEmbeddedReport();
        return (
            <div>
                {reportList}
                <br />
                {this.state.selectedReport.id &&
                    <React.Fragment>
                        <Grid container spacing={24}>
                            <Grid item xs={12}>
                            {this.props.userRole === UserRoles.SuperUser &&
                                    <div>
                                        <h4>Embed Code</h4>
                                        <pre><code>{this.getReportUrl()}</code></pre>
                                    </div>
                                }
                            </Grid>
                        </Grid>
                        {embeddedReport}
                    </React.Fragment>
                }
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Hospitals/Reports.js